// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-wrapper {
  font-family: 'Montserrat', sans-serif;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;

  background-color: #f5f7f9;
}


.form-conatiner {
  box-shadow: 0px 0px 20px 4px #0000001F;
  background: #FFFFFF;
  border-radius: 12px;
  padding: 24px;
  width: 100%;
  max-width: 420px;
}


.login-title {
  color: #000;
  text-align: center;
  margin-bottom: 1.5rem;
  font-size: 1.75rem;
  font-weight: 600;
}


.form-group {
  margin-bottom: 1rem;
}


.form-label {
  display: block;
  color: #000;
  font-weight: 500;
  font-size: 0.95rem;
}


.login-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 40px;
  background-color: #C39B22;
  color: #fff;
  border: 2px solid transparent;
  border-radius: 12px;
  font-size: 1rem;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.3s ease;
  gap: 2px;
}

.login-btn:hover {
  background-color: #a37f1a;
}

.login-btn:active {
  border: 2px solid #000;
}

/* 
.login-btn:focus {
  outline: none;
  border: 2px solid #000;
} */

.form-conatiner img {
  height: 60px;
  width: 60px;
  display: block;
  margin: 0 auto;
  max-width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Auth/auth.css"],"names":[],"mappings":"AAEA;EACE,qCAAqC;EACrC,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,yBAAyB;AAC3B;;;AAGA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;;;AAGA;EACE,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;;AAGA;EACE,mBAAmB;AACrB;;;AAGA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;;GAIG;;AAEH;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,cAAc;EACd,eAAe;AACjB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap');\n\n.login-wrapper {\n  font-family: 'Montserrat', sans-serif;\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  background-color: #f5f7f9;\n}\n\n\n.form-conatiner {\n  box-shadow: 0px 0px 20px 4px #0000001F;\n  background: #FFFFFF;\n  border-radius: 12px;\n  padding: 24px;\n  width: 100%;\n  max-width: 420px;\n}\n\n\n.login-title {\n  color: #000;\n  text-align: center;\n  margin-bottom: 1.5rem;\n  font-size: 1.75rem;\n  font-weight: 600;\n}\n\n\n.form-group {\n  margin-bottom: 1rem;\n}\n\n\n.form-label {\n  display: block;\n  color: #000;\n  font-weight: 500;\n  font-size: 0.95rem;\n}\n\n\n.login-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 40px;\n  background-color: #C39B22;\n  color: #fff;\n  border: 2px solid transparent;\n  border-radius: 12px;\n  font-size: 1rem;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  gap: 2px;\n}\n\n.login-btn:hover {\n  background-color: #a37f1a;\n}\n\n.login-btn:active {\n  border: 2px solid #000;\n}\n\n/* \n.login-btn:focus {\n  outline: none;\n  border: 2px solid #000;\n} */\n\n.form-conatiner img {\n  height: 60px;\n  width: 60px;\n  display: block;\n  margin: 0 auto;\n  max-width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
